import { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import useStyles from "../style";
import { Box, Button, Divider, Skeleton, Typography } from "@mui/material";
import useForm from "../Validacao/useForm";
import "../CartaoCss.css";
import { useMutation } from "react-query";
import { SaveCartao, GetServicoCartao } from "../../../api/FormaPagamento";
import { useAuth } from "../../../hooks/AuthContext";
import useAlert from "../../../hooks/useAlert";
import { configurationVariables } from "../../../environment";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import InputMask from "react-input-mask";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  BANDEIRAS_ACEITAS,
  detectarBandeira,
  validarNumeroCartao,
  validarDataExpiracao,
  validarCVV,
  isBandeiraSuportada,
  detectarBandeiraProvisoria,
} from "../../../util/creditCardValidation";
import BandeirasAceitas from "../../../components/BandeirasAceitas";

const CadastrarCartao = ({ setShowListaCartao }) => {
  const classes = useStyles();
  const { user } = useAuth();
  const { showAlertError, showAlertSuccess } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [bandeiraAtual, setBandeiraAtual] = useState(null);
  const [bandeiraSuportada, setBandeiraSuportada] = useState(true);
  const [servicoCartao, setServicoCartao] = useState("");
  const [numeroFormatado, setNumeroFormatado] = useState(""); // Estado para o número formatado (com máscara)
  const [numeroLimpo, setNumeroLimpo] = useState(""); // Estado para o número limpo (sem formatação)

  const {
    handleChange,
    handleFocus,
    handleSubmit,
    setIsValidCampos,
    isValidCampos,
    values: cartao,
    errors,
  } = useForm();

  // Função para formatar o número do cartão
  const formatarNumeroCartao = (valor) => {
    // Remove tudo que não é número
    const apenasNumeros = valor.replace(/\D/g, '');
    
    // Aplica a formatação: XXXX XXXX XXXX XXXX
    if (apenasNumeros.length <= 4) {
      return apenasNumeros;
    } else if (apenasNumeros.length <= 8) {
      return `${apenasNumeros.slice(0, 4)} ${apenasNumeros.slice(4)}`;
    } else if (apenasNumeros.length <= 12) {
      return `${apenasNumeros.slice(0, 4)} ${apenasNumeros.slice(4, 8)} ${apenasNumeros.slice(8)}`;
    } else {
      return `${apenasNumeros.slice(0, 4)} ${apenasNumeros.slice(4, 8)} ${apenasNumeros.slice(8, 12)} ${apenasNumeros.slice(12, 16)}`;
    }
  };

  // Função para lidar com mudanças no campo do cartão
  const handleChangeCartao = (e) => {
    const { name, value } = e.target;
    
    if (name === "numero") {
      const valorFormatado = formatarNumeroCartao(value);
      const apenasNumeros = valorFormatado.replace(/\s/g, "");
      
      // Atualiza ambos os estados
      setNumeroFormatado(valorFormatado);
      setNumeroLimpo(apenasNumeros);
      
      // Chama o handleChange original com o valor limpo
      handleChange({ 
        target: { 
          name: "numero", 
          value: apenasNumeros 
        } 
      });
    } else {
      handleChange(e);
    }
  };

  // Função para lidar com colagem (paste)
  const handlePasteCartao = (e) => {
    e.preventDefault();
    const textoColado = e.clipboardData.getData('text');
    const valorFormatado = formatarNumeroCartao(textoColado);
    const apenasNumeros = valorFormatado.replace(/\s/g, "");
    
    setNumeroFormatado(valorFormatado);
    setNumeroLimpo(apenasNumeros);
    
    handleChange({ 
      target: { 
        name: "numero", 
        value: apenasNumeros 
      } 
    });
  };

  const initServico = async () => {
    await GetServicoCartao()
      .then((resp) => {
        setServicoCartao(resp.data);
      })
      .catch((err) => {
        showAlertError(
          `Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: ${err.message} - RG7ZB `
        );
      });
  };

  useEffect(() => {
    initServico();
  }, []);

  useEffect(() => {
    let script = document.createElement("script");
    script.src = "https://js.iugu.com/v2";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Atualizar bandeira quando o número do cartão mudar
  useEffect(() => {
    // Usa o número limpo para detecção da bandeira
    const numeroParaValidacao = numeroLimpo || cartao.numero?.replace(/\s/g, "") || "";

    // Limpa a bandeira se o número for muito curto
    if (numeroParaValidacao.length < 6) {
      setBandeiraAtual(null);
      setBandeiraSuportada(true);
      return;
    }

    // Detecta bandeira provisória
    const bandeira = detectarBandeira(numeroParaValidacao);
    setBandeiraAtual(bandeira);

    if (bandeira) {
      const suportada = isBandeiraSuportada(bandeira);
      setBandeiraSuportada(suportada);

      // MOSTRA ERRO APENAS SE O NÚMERO ESTIVER COMPLETO E A BANDEIRA NÃO FOR SUPORTADA
      if (!suportada && numeroParaValidacao.length >= 16) {
        showAlertError(
          "Bandeira não aceita. Aceitamos: Visa, Mastercard, Amex, Hipercard e Elo"
        );
      }
    } else {
      setBandeiraSuportada(true);
    }
  }, [numeroLimpo, cartao.numero]);

  const mutationSaveCard = useMutation({
    mutationFn: SaveCartao,
    onSuccess: (resp) => {
      // Verifique se há erro na resposta da API
      if (resp?.errorMessage) {
        showAlertError(`Ops Algo deu errado, ${resp.errorMessage} - RGF1C`);
        return;
      } else showAlertSuccess("Cartão cadastrado com sucesso");

      setShowListaCartao();
    },
    onError: (error) => {
      showAlertError(`Ops Algo deu errado, ${error?.message} - RYZ0C`);
    },
    onSettled: () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    },
  });

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    // Verificar se a bandeira é suportada antes de submeter
    if (bandeiraAtual && !bandeiraSuportada) {
      showAlertError(
        "Bandeira não aceita. Por favor, use um cartão com bandeira suportada."
      );
      return;
    }

    handleSubmit(event);
    handlerCadastrarCartao(event);
  };

  const validaCartao = () => {
    // Usa o número limpo para validação
    const numeroParaValidacao = numeroLimpo || cartao.numero?.replace(/\s/g, "") || "";

    // VERIFICAÇÃO PRINCIPAL: Só valida bandeira se o número estiver completo
    if (numeroParaValidacao.length >= 16) {
      if (bandeiraAtual && !bandeiraSuportada) {
        showAlertError(
          "Bandeira não aceita. Aceitamos: Visa, Mastercard, Amex, Hipercard e Elo"
        );
        return false;
      }
    }
    // Usar nossas próprias validações
    let bandeira = bandeiraAtual;
    const isValidNumber = validarNumeroCartao(numeroParaValidacao);
    const isValidData = validarDataExpiracao(cartao.dataExpiracao);
    const isValidCVV = validarCVV(cartao.cvc, bandeiraAtual);

    if (!isValidNumber) {
      setIsValidCampos((state) => ({ ...state, cNumber: false }));
      showAlertError("O número do cartão informado é inválido");
      return false;
    } else {
      setIsValidCampos((state) => ({ ...state, cNumber: true }));
    }

    if (!isValidData) {
      setIsValidCampos((state) => ({ ...state, cData: false }));
      showAlertError("A data de expiração informada é inválida");
      return false;
    } else {
      setIsValidCampos((state) => ({ ...state, cData: true }));
    }

    if (!isValidCVV) {
      setIsValidCampos((state) => ({ ...state, cCvv: false }));
      showAlertError(
        "O código de segurança informado não corresponde ao cartão"
      );
      return false;
    } else {
      setIsValidCampos((state) => ({ ...state, cCvv: true }));
    }

    return { isValid: true, bandeira: bandeira };
  };

  const saveCard = async (contentData) => {
    let newCard = {
      idCliente: user.id,
      numero: numeroLimpo, // Usa o número limpo (sem formatação)
      bandeira: contentData.bandeira,
      nomeTitular: cartao.nomeTitular,
      hashCartao: contentData.id,
      codigoVerificado: cartao.cvc,
      dataValidade: cartao.dataExpiracao,
    };

    mutationSaveCard.mutate(newCard);
  };

  // Se ainda precisa do Iugu para criação do token de pagamento
  const handlerCadastrarCartao = async (event) => {
    event.preventDefault();
    let [mes, ano] = cartao.dataExpiracao.split("/");
    let [primeiroNome, ...sobrenome] = cartao.nomeTitular.split(" ");
    let { isValid, bandeira } = validaCartao();

    if (isValid) {
      setIsLoading(() => true);

      if (servicoCartao === "Iugu") {
        let creditCard = window.Iugu.CreditCard(
          numeroLimpo, // Usa o número limpo aqui também
          mes,
          ano,
          primeiroNome,
          sobrenome.join(" "),
          cartao.cvc
        );
        window.Iugu.createPaymentToken(creditCard, function (response) {
          if (response?.errors) {
            checkErrors(response);
          } else {
            saveCard({
              id: response.id,
              bandeira: response.extra_info.brand,
            });
          }
        });
      } else {
        saveCard({
          id: "0",
          bandeira: bandeira,
        });
      }
    }
  };

  const checkErrors = (contentData) => {
    let textError = Object.keys(contentData.errors).reduce(
      (prevValue, nextValue, index) => {
        let value = "";
        if (nextValue === "number") value = "numero do cartão";

        if (nextValue === "verification_value") value = "codigo de segurança ";

        if (nextValue === "expiration") value = "data de expiração";

        if (nextValue === "last_name") value = "nome do titular";

        return ` ${value}, ${prevValue}`;
      },
      ""
    );
    showAlertError(`Ops, algo deu errado nos seguintes campos: ${textError} `);
    setIsLoading(() => false);
  };

  return (
    <div>
      {isLoading ? (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%",
            }}
          >
            <Skeleton variant="rectangular" height={180} />
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" height={40} />
            ))}
          </Box>
        </>
      ) : (
        <>
          <Typography
            variant="body2"
            color="primary"
            style={{
              cursor: "pointer",
              marginBottom: 15,
              alignItems: "center",
              display: "flex",
            }}
            onClick={setShowListaCartao}
          >
            <ArrowBackIosOutlinedIcon sx={{ mr: 1 }} fontSize="12" /> Escolher
            outro cartão
          </Typography>

          {/* Componente para mostrar bandeiras aceitas */}
          <BandeirasAceitas />

          <div className="creditCard">
            <Cards
              cvc={"*".repeat(cartao.cvc.length)}
              expiry={cartao.dataExpiracao}
              focused={cartao.focus}
              name={cartao.nomeTitular}
              number={numeroFormatado} // Usa o número formatado para exibição
            />

            {/* Indicador de bandeira detectada */}
            {bandeiraAtual && (
              <Box
                className={
                  bandeiraSuportada
                    ? "bandeira-suportada"
                    : "bandeira-nao-suportada"
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 1,
                }}
              ></Box>
            )}
          </div>

          <Form onSubmit={handleFormSubmit}>
            <Form.Group style={{ marginBottom: 15 }}>
              <Form.Control
                required
                id="cardNumber"
                data-testid="cardNumber"
                name="numero"
                maxLength={19} // Aumentado para 19 (16 números + 3 espaços)
                placeholder="1234 5678 9012 3456"
                value={numeroFormatado} // Usa o número formatado
                onChange={handleChangeCartao} // Usa a nova função
                onPaste={handlePasteCartao} // Adiciona handler para paste
                onFocus={handleFocus}
                isValid={isValidCampos.cNumber && bandeiraSuportada}
                isInvalid={!!numeroLimpo && !bandeiraSuportada}
              />
              {!!numeroLimpo && !bandeiraSuportada && (
                <Typography
                  sx={{
                    mb: 2,
                    fontSize: 12,
                    ml: 1,
                    opacity: 0.7,
                    color: "red",
                  }}
                >
                  Bandeira não aceita ou número inválido
                </Typography>
              )}
            </Form.Group>

            {/* Restante do seu código permanece igual */}
            <Form.Group>
              <Form.Control
                required
                type="text"
                id="cardName"
                data-testid="cardName"
                name="nomeTitular"
                placeholder="Nome Completo"
                value={cartao.nomeTitular}
                onChange={handleChange}
                onFocus={handleFocus}
                isValid={isValidCampos.cNome}
              />
              <Typography sx={{ mb: 2, fontSize: 12, ml: 1, opacity: 0.7 }}>
                Conforme aparece no cartão
              </Typography>
            </Form.Group>

            <Row>
              <Col>
                <Form.Group>
                  <InputMask
                    mask="99/99"
                    value={cartao.dataExpiracao}
                    onChange={handleChange}
                    onFocus={handleFocus}
                  >
                    {() => (
                      <Form.Control
                        required
                        type="text"
                        id="cardExpiration"
                        data-testid="cardExpiration"
                        name="dataExpiracao"
                        placeholder="Validade"
                        isValid={isValidCampos.cData}
                      />
                    )}
                  </InputMask>
                  <Typography sx={{ mb: 2, fontSize: 12, ml: 1, opacity: 0.7 }}>
                    Mês/Ano
                  </Typography>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group>
                  <Form.Control
                    required
                    id="cardSecurityCode"
                    data-testid="cardSecurityCode"
                    name="cvc"
                    placeholder="Código de Segurança"
                    value={cartao.cvc}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    isValid={isValidCampos.cCvv}
                    maxLength={4}
                  />
                  <Typography sx={{ mb: 2, fontSize: 12, ml: 1, opacity: 0.7 }}>
                    CVC
                  </Typography>
                </Form.Group>
              </Col>
            </Row>

            <Button
              className={classes.Button}
              variant="contained"
              data-testid="validateButton"
              id="validateButton"
              type="submit"
              disabled={
                !numeroLimpo || // Usa o número limpo para validação
                !cartao.nomeTitular ||
                !cartao.dataExpiracao ||
                !cartao.cvc
              }
            >
              Continuar
            </Button>
          </Form>
        </>
      )}
    </div>
  );
};

export default CadastrarCartao;